'use client';
import { H1, TabMenu } from '@template/components';
import * as S from './styles.ts';
import { IImageProps } from '@/lib/types/components';

interface ITabSectionComponentProps {
  heading?: string;
  tabs?: {
    title: string;
    icon?: string;
    subtitle: string;
    bullets: { copy: string; href?: string }[];
    image?: IImageProps;
  }[];
  alternative_styling?: boolean;
}

const TabSectionComponent = ({
  heading,
  tabs,
  alternative_styling,
}: ITabSectionComponentProps) => {
  return (
    <S.TabSectionWrapper $alternativeStyling={alternative_styling}>
      <S.TabSectionContainer>
        <H1 as='h2'>{heading}</H1>
        {tabs && <TabMenu tabs={tabs} />}
      </S.TabSectionContainer>
    </S.TabSectionWrapper>
  );
};

export default TabSectionComponent;

export const options = [
  {
    description: '',
    displayName: 'TabSectionComponent',
    methods: [],
    props: {
      heading: {
        required: false,
        flowType: { name: 'string' },
        description: '',
      },
      tabs: {
        required: false,
        flowType: {
          name: 'Array',
          elements: [
            {
              name: 'signature',
              type: 'object',
              raw: '{\n  title: string;\n  icon?: IconType;\n  subtitle: string;\n  bullets: { copy: string; href?: string }[];\n  image?: IImageProps;\n}',
              signature: {
                properties: [
                  {
                    key: 'title',
                    value: {
                      name: 'string',
                      required: true,
                    },
                  },
                  {
                    key: 'icon',
                    value: {
                      name: 'IconType',
                      required: false,
                    },
                  },
                  {
                    key: 'subtitle',
                    value: {
                      name: 'string',
                      required: true,
                    },
                  },
                  {
                    key: 'bullets',
                    value: {
                      name: 'Array',
                      elements: [
                        {
                          name: 'signature',
                          type: 'object',
                          raw: '{ copy: string; href?: string }',
                          signature: {
                            properties: [
                              {
                                key: 'copy',
                                value: {
                                  name: 'string',
                                  required: true,
                                },
                              },
                              {
                                key: 'href',
                                value: {
                                  name: 'string',
                                  required: false,
                                },
                              },
                            ],
                          },
                        },
                      ],
                      raw: '{ copy: string; href?: string }[]',
                      required: true,
                    },
                  },
                  {
                    key: 'image',
                    value: {
                      name: 'IImageProps',
                      required: false,
                    },
                  },
                ],
              },
            },
          ],
          raw: '{\n  title: string;\n  icon?: IconType;\n  subtitle: string;\n  bullets: { copy: string; href?: string }[];\n  image?: IImageProps;\n}[]',
        },
        description: '',
      },
    },
  },
];
